// extracted by mini-css-extract-plugin
export default {"map":"CreateOpportunityDetails_map__YxwAa"};